import React from 'react';
import { Card, CardHeader, CardContent, TextField } from '@mui/material';

export default function ImportantNotes ({ formik }) {
  return (
    <Card>
      <CardHeader title="Ważne uwagi"/>
      <CardContent>
        <TextField
          id="important_notes"
          value={formik.values.important_notes}
          onChange={formik.handleChange}
          multiline
          rows={8}
          fullWidth
        />
      </CardContent>
    </Card>
  );
};
